import { env } from "../Env"
import { rqx } from "../request/API"

export const uploadToS3Presigned = async (file, params) => {
    console.log(file);
    const { requestRef, feature_ref, tool_id, privacy = 'private' } = params
    const body = {
        rqxRef: requestRef,
        file_name: file[0].name,
        file_type: file[0].type,
        size: file[0].size,
        feature_ref,
        tool_id,
        env: env(),
        privacy
    }

    const rqxPreSigned = await rqx.post(
        `<<s3>>/${env()}/glbl/transmit/uploadRqx`,
        body
    )
    const { uploadUrl } = rqxPreSigned
    await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
        'Content-Type': file[0].type
    },
        body: file[0]
    })
    return rqxPreSigned
}